<template>
    <div class="ComplaintProposalPraise" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>投诉与建议</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                         <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" label-width="100px">
                                <el-form-item label="类型">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option
                                        v-for="item in TypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="ExportComplaintProposalPraise">导出</el-button>
                        <!-- <el-button type="primary" @click="AddComplaintProposalPraise">新增</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" border style="width: 100%" :height="Height - 265">
                    <el-table-column prop="create_time" label="日期">
                    </el-table-column>
                    <el-table-column prop="title" label="标题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="content" label="内容描述" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="SeeComplaintProposalPraise(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-drawer
                    :title="DetailsData.title"
                    :visible.sync="drawer"
                    direction="rtl"
                    @opened="DrawerEnd">
                    <div class="content">
                        <span>{{DetailsData.content}}</span>
                    </div>
                    <!-- <div class="ComplaintProposalPraiseDetails" :style="{'min-height': Height - 105 + 'px'}">
                        <div class="comment" :style="{'min-height': Height - 125 + 'px'}">
                            <el-row class="commentTitle">
                                <el-col>
                                    <i class="el-icon-chat-dot-round"></i>
                                    <span>评论</span>
                                </el-col>
                            </el-row>
                            <div class="commentmain" :style="{height: Height - 226 + 'px'}">
                                <ul>
                                    <li :key="item.id" v-for="item in commentList">
                                        <div class="title">
                                            {{item.username}}:
                                        </div>
                                        <div class="body">
                                            {{item.comment}}
                                        </div>
                                        <div class="footer">
                                            <span>{{item.deal_time}}</span>
                                            <i class="el-icon-delete" @click="DeleteComment(item)"></i>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="commentfooter">
                                <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入评论"
                                    v-model="comment">
                                </el-input>
                                <el-button type="text" @click="commentAdd" :loading="confirmloding">评论</el-button>
                            </div>
                        </div>
                    </div> -->
                </el-drawer>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "ComplaintProposalPraise",
    data () {
        return {
            http: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            currentPage: 1,
            Size: 20,
            total: 1,
            type: 1,
            TypeList: [{
                value: 1,
                label: '投诉'
            }, {
                value: 2,
                label: '建议'
            }],
            DetailsData: [],
            drawer: false,
            comment: '',
            commentList: [],
            confirmloding: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        ExportComplaintProposalPraise () {
            let that = this
            this.fullscreenLoading = true
            let data = {
                limit: this.Size,
                page: this.currentPage,
                type: this.type,
                admin_id: getAdminId(),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                is_excel: 1
            }
            this.$store.dispatch('ExportComplaintProposalPraise', data).then(res => {
                let link = document.createElement('a')
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = '投诉建议' // 下载的文件名
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.fullscreenLoading = false
            })
        },
        handleSizeChange (size) {
            this.Size = size
            this.GetComplaintProposalPraiseList()
        },
        handleCurrentChange (page) {
            this.currentPage = page
            this.GetComplaintProposalPraiseList()
        },
        AddComplaintProposalPraise () {
        },
        GetComplaintProposalPraiseList() {
            let data = {
                limit: this.Size,
                page: this.currentPage,
                type: this.type,
                admin_id: getAdminId(),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('ComplaintProposalPraiseListShow', data).then(res => {
                this.visible = false
                this.fullscreenLoading = false
                this.tableData = res.data
            })
        },
        Reset () {
            this.type = 1
        },
        ConfirmQuery () {
            this.currentPage = 1
            this.GetComplaintProposalPraiseList()
        },
        SeeComplaintProposalPraise (row) {
            this.DetailsData = row
            this.drawer = true
            this.GetCommentList()
        },
        DrawerEnd() {
        },
        GetCommentList() {
            let data = {
                id: this.DetailsData.id,
                admin_id: getAdminId(),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CommentListShow', data).then(res => {
                this.commentList = res.data
            })
        },
        commentAdd () {
            if (this.comment !== '') {
                let data = {
                    id: this.DetailsData.id,
                    comment: this.comment,
                    admin_id: getAdminId(),
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken()
                }
                this.confirmloding = true
                this.$store.dispatch('ComplaintProposalPraiseCommentAdd', data).then(res => {
                    if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.confirmloding = false
                        this.comment = ''
                        this.GetCommentList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            } else {
                this.$message({
                    message: '评论不能为空',
                    type: 'warning'
                })
            }
        },
        DeleteComment (row) {
            let data = {
                id: row.id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$confirm('是否删除评论？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$store.dispatch('ComplaintProposalPraiseCommentDelete', data).then(res => {
                        if (res.flag) {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            })
                            this.GetCommentList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                }).catch(() => {
                });
        }
    },
    created() {
        this.GetComplaintProposalPraiseList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.ComplaintProposalPraise {
    width: 100%;
}
.ComplaintProposalPraise .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.ComplaintProposalPraise .el-header .el-row .el-col h2 {
    text-align: center;
}
.ComplaintProposalPraise .el-header .el-row .el-col {
    text-align: center;
}
.ComplaintProposalPraise .el-header .el-row .el-col:last-child {
    text-align: right;
}
.ComplaintProposalPraise .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body {
    color: #666;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .content {
    min-height: 30px;
    padding: 0px 20px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails {
    background-color: #f4f4f4;
    overflow: auto;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment {
    background-color: #fff;
    margin-top: 20px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .el-row .el-col {
    height: 40px;
    line-height: 40px;
    padding: 0px 20px;
    border-bottom: 1px solid #999;
    background-color: #fff;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .el-row .el-col i {
    font-size: 26px;
    margin-top: 5px;
    margin-right: 5px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .el-row .el-col span {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    vertical-align: top;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain {
    padding: 0px 20px;
    overflow: auto;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li {
    background-color: #fff;
    margin-top: 20px;
    overflow: hidden;
    border-bottom: 1px solid #999;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .title {
    height: 30px;
    line-height: 30px;
    padding: 0px 20px;
    /* border-bottom: 1px solid #999; */
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .body {
    padding: 0px 40px;
    margin: 10px 0;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .footer {
    height: 30px;
    line-height: 30px;
    text-align: right;
    padding: 0px 20px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .footer i {
    font-size: 20px;
    height: 30px;
    vertical-align: top;
    line-height: 30px;
    width: 40px;
    text-align: center;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .footer i:hover {
    cursor: pointer;
    color: #409eff;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentmain ul li .footer span {
    display: inline-block;
    height: 30px;
    line-height: 30px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentfooter {
    height: 61px;
    border-top: 1px solid #999;
    background-color: #fff;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentfooter textarea {
    height: 60px;
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentfooter .el-textarea {
    width: calc(100% - 100px);
}
.ComplaintProposalPraise .el-main .el-drawer__container .el-drawer__body .ComplaintProposalPraiseDetails .comment .commentfooter .el-button {
    width: 100px;
    height: 60px;
}
</style>
